import { render } from "./DashboardEntry.vue?vue&type=template&id=056c316a"
import script from "./DashboardEntry.vue?vue&type=script&lang=js"
export * from "./DashboardEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__